@if (message.isShownInChat !== false && !message.isHidden) {
<div class="chat-v2-bubble-wrapper flex flex-col w-full mb-6"
     [ngClass]="message.isUser ? 'items-end' : 'items-start'">

  @switch (message.type) {

    <!-- 1. SPECIAL CASE: Action Response Centered Pill Layout -->
    @case ('action-response') {
    <div class="flex flex-col w-full items-center my-3 gap-2 animate-fade-in">

      @if (message.actionResponseData) {
      <button (click)="showActionResponseInCanvas()"
              class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-xs text-xs font-medium text-secondary-text hover:text-primary hover:border-primary transition-colors focus:outline-none max-w-[90%] cursor-pointer">
        <i class="fas"
           [ngClass]="(message.isError || message.actionResponseData.actionResponseStatus === 'error') ? 'fa-exclamation-circle text-danger' : 'fa-check-circle text-success'"></i>
        <span class="truncate">
          @if (message.actionResponseData.actionType === 'rapider-workflow' && message.actionResponseData.actionResponseStatus === 'success') {
          <ng-container i18n="@@workflowStartedSuccessfully">Workflow started successfully</ng-container>
          } @else {
          {{ message.text }}
          }
        </span>
      </button>
      }

      @if (message.workflowPlanUpdate) {
      <div class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-xs text-xs font-medium text-secondary-text max-w-[90%]">
        <i class="fas"
           [ngClass]="message.workflowPlanUpdate.status === 'failed' ? 'fa-times-circle text-danger' : 'fa-check-circle text-success'"></i>
        <span class="truncate">{{ message.text }}</span>
      </div>
      }

      @if (message.transformationResult) {
      <div class="flex flex-col items-center gap-2 w-full max-w-[85%] sm:max-w-[75%] rounded-xl shadow-xs border border-secondary-border bg-component-inner overflow-hidden mb-1">
        <div class="px-4 py-2 border-b border-secondary-border bg-alt-background flex items-center gap-2 w-full">
          <i class="fas fa-check-circle text-success text-xs"></i>
          <span class="text-[11px] font-bold uppercase tracking-wider text-primary-text"
                i18n="@@aiChat.transformationResultTitle">Transformation Result</span>
        </div>
        <div class="p-3 bg-alt-background overflow-x-auto max-h-[250px] custom-scrollbar w-full">
          <pre class="text-[11px] text-primary-text m-0">{{ message.transformationResult | json }}</pre>
        </div>
      </div>
      }

      @if (!message.actionResponseData && !message.workflowPlanUpdate && !message.transformationResult) {
      <div class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-xs text-xs font-medium text-secondary-text max-w-[90%]">
        <i class="fas fa-check-circle text-success"></i>
        <span class="truncate">{{ message.text }}</span>
      </div>
      }

      @if (message.asyncProgress) {
      <div class="w-full max-w-[850px] mt-1">
        <rapider-chat-async-progress-card [progress]="message.asyncProgress"
                                          [attachments]="message.attachments"
                                          (fetchLogs)="onFetchLogs($event)">
        </rapider-chat-async-progress-card>
      </div>
      }

    </div>
    }

    <!-- 2. SPECIAL CASE: Workflow Step Progress Card -->
    @case ('workflow-step') {
    <div class="flex flex-col w-full max-w-[850px] rounded-xl shadow-xs border border-secondary-border bg-component-inner overflow-hidden mb-2 min-w-[280px] sm:min-w-[400px] animate-fade-in">
      <div class="px-4 py-3 border-secondary-border bg-alt-background flex items-center justify-between cursor-pointer hover:bg-hover-default transition-colors"
           [ngClass]="!isWorkflowStepCollapsed() ? 'border-b' : ''"
           (click)="toggleWorkflowStepCollapse()">
        <div class="flex flex-wrap items-center gap-2">
          <nz-tag class="!m-0 text-[11px] font-black bg-primary/10 text-primary border-primary/20 shadow-xs px-2">
            {{ (message.workflowStepData?.stepIndex ?? 0) + 1 }}
          </nz-tag>
          <nz-tag class="!m-0 text-[10px] font-bold uppercase tracking-wider bg-section-background border-secondary-border text-primary-text shadow-xs flex items-center">
            <i class="fas {{ getTaskTheme(message.aiFunctionId || '').icon }} mr-1 text-primary"></i>
            {{ getTaskTheme(message.aiFunctionId || '').title }}
          </nz-tag>
          <nz-tag class="!m-0 text-[9px] font-bold uppercase tracking-wider !bg-component-inner !text-secondary-text !border-secondary-border !rounded-full border border-dashed flex items-center gap-1">
            <i class="fas fa-circle-notch fa-spin text-primary"></i>
            <span i18n="@@aiChat.statusInProgress">In Progress</span>
          </nz-tag>
        </div>
        <div class="flex items-center gap-3">
          <i class="fas text-secondary-text transition-transform text-xs"
             [ngClass]="isWorkflowStepCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </div>
      </div>
      @if (!isWorkflowStepCollapsed()) {
      <div class="p-4 bg-component-inner animate-fade-in">
        <p class="text-[13px] text-primary-text whitespace-pre-wrap leading-relaxed mb-0">
          {{ message.workflowStepData?.description || message.text }}
        </p>
      </div>
      }
    </div>
    }

    <!-- 3. DEFAULT CASE: Standard Chat V2 Message Bubble -->
    @default {

      <!-- 3.1 ABOVE BUBBLE: Reasoning Block (Streaming Shimmer or Static Done Timeline) -->
      @if (hasReasoning) {
      <div class="chat-v2-reasoning-wrapper w-full max-w-[850px] mb-2 animate-fade-in">
        <rapider-chat-v2-reasoning-block
          [steps]="reasoningSteps"
          [isStreaming]="isStreaming"
          [agentName]="agentName"
          [forceWorkingShimmer]="forceWorkingShimmer"
          [forceDoneHeader]="forceDoneHeader"
          [animated]="shouldAnimateReasoning"
          (onPlaybackComplete)="handleReasoningPlaybackComplete()">
        </rapider-chat-v2-reasoning-block>
      </div>
      }

      <!-- 3.2 ABOVE BUBBLE: Tool Calls (if present) -->
      @if (hasToolCalls) {
      <div class="chat-v2-tool-calls-wrapper flex flex-col gap-1.5 w-full max-w-[850px] mb-2 animate-fade-in">
        @for (toolCall of message.toolCalls; track toolCall.id || $index) {
          <rapider-chat-tool-call-card [toolCall]="toolCall"></rapider-chat-tool-call-card>
        }
      </div>
      }

      <!-- 3.3 ABOVE BUBBLE: Async Progress Card (if present) -->
      @if (hasAsyncProgress && message.asyncProgress) {
      <div class="chat-v2-async-wrapper w-full max-w-[850px] mb-2 animate-fade-in">
        <rapider-chat-async-progress-card
          [progress]="message.asyncProgress"
          [attachments]="message.attachments"
          (fetchLogs)="onFetchLogs($event)">
        </rapider-chat-async-progress-card>
      </div>
      }

      <!-- 3.4 MESSAGE BUBBLE CONTAINER (Zero-Empty-Bubble: strictly suppressed when shouldRenderBubbleContainer is false) -->
      @if (shouldRenderBubbleContainer) {
      <div class="chat-v2-bubble-container flex flex-col relative transition-all animate-fade-in"
           [ngClass]="message.isUser
             ? 'bg-alt-background border border-primary-border text-primary-text rounded-2xl px-4.5 pt-3.5 pb-2.5 max-w-[82%] gap-2 is-user shadow-2xs'
             : 'text-primary-text max-w-[850px] w-full gap-3 px-0 py-1 bg-transparent border-none shadow-none is-ai'">

        <!-- Voice Message Audio Player -->
        @if (message.isVoiceMessage) {
        <div class="chat-v2-voice-player flex flex-col gap-1 w-full my-1">
          @if (message.voiceUrl || localVoiceUrl()) {
          <audio controls
                 [autoplay]="autoPlayAudio()"
                 [src]="localVoiceUrl() || message.voiceUrl"
                 class="w-full h-[48px] outline-none rounded-full bg-alt-background border border-secondary-border shadow-xs"></audio>
          } @else {
          <button (click)="loadAudioBlob()"
                  [disabled]="isLoadingAudio()"
                  class="h-[48px] w-full bg-alt-background border border-secondary-border rounded-full flex items-center px-4 gap-3 hover:bg-hover-default transition-colors shadow-xs focus:outline-none cursor-pointer disabled:cursor-wait disabled:opacity-90">
            <div class="w-7 h-7 flex items-center justify-center shrink-0 text-primary-text">
              @if (isLoadingAudio()) {
              <i class="fas fa-circle-notch fa-spin text-base text-primary"></i>
              } @else {
              <i class="fas fa-play ml-0.5 text-xs"></i>
              }
            </div>
            <span class="text-xs text-primary-text font-medium shrink-0">{{ config.texts.voiceMessageLabel }}</span>
            <div class="flex-1 h-1 bg-secondary-border rounded-full overflow-hidden mx-2"></div>
            <i class="fas fa-volume-up text-xs text-secondary-text shrink-0"></i>
          </button>
          }
          @if (audioError()) {
          <span class="text-[10px] text-warning font-semibold leading-tight mt-1">{{ config.texts.voiceExpiredError }}</span>
          }

          <!-- Voice Message Transcription Display -->
          @if (message.transcribedMessage || (message.text && !message.voiceUrl && !localVoiceUrl())) {
          <div class="px-3 py-1.5 text-xs italic text-secondary-text border-l-2 border-primary/50 my-1 bg-alt-background/60 rounded-r">
            "{{ message.transcribedMessage || message.text }}"
          </div>
          }
        </div>
        }

        <!-- Message Content: Text / Markdown with Smooth Typewriter & Click-to-Skip -->
        @if (message.text && !message.isVoiceMessage) {
        <div class="chat-v2-message-content leading-relaxed w-full min-w-0"
             [ngClass]="{'markdown-normalize text-base ai-message': !message.isUser, 'text-sm': message.isUser}"
             (click)="handleBubbleClick()">
          @if (message.isUser) {
          <span class="whitespace-pre-wrap">{{ message.text }}</span>
          } @else if (pipeline.isTyping()) {
          <div class="chat-v2-typewriter-wrapper inline">
            <rapider-markdown-preview
              [data]="pipeline.displayedText()"
              [viewMode]="'compact'"
              [showHeader]="false"
              [showBorder]="false"
              [isTransparent]="true">
            </rapider-markdown-preview>
            <span class="chat-v2-typing-cursor" aria-hidden="true"></span>
          </div>
          } @else {
          <rapider-markdown-preview
            [data]="message.text"
            [viewMode]="'compact'"
            [showHeader]="false"
            [showBorder]="false"
            [isTransparent]="true">
          </rapider-markdown-preview>
          }
        </div>
        }

        <!-- Attachments Section (Phased reveal with Preview, Open in Tab, and Download) -->
        @if (visibleAttachments.length > 0 && canShowAttachments) {
        <div class="chat-v2-attachments-section flex flex-wrap gap-2 pt-2 border-t border-secondary-border/60">
          @for (file of visibleAttachments; track file.id || $index) {
          <div class="flex items-center gap-1.5 bg-alt-background border border-secondary-border rounded-lg px-2.5 py-1.5 hover:border-primary transition-all group/attachment shadow-2xs">
            <div (click)="handleAttachmentClick(file)"
                 class="flex items-center gap-2 cursor-pointer focus:outline-none"
                 [title]="file.name">
              <i [class]="getFileIcon(file) + ' text-primary'"></i>
              <span class="truncate max-w-[150px] font-medium text-xs text-primary-text">{{ file.name }}</span>
              <span class="text-[10px] text-secondary-text">{{ formatSize(file.size) }}</span>
            </div>
            <div class="flex items-center gap-1 ml-1 pl-1.5 border-l border-secondary-border/50">
              @if (isPreviewable(file)) {
              <button (click)="openInNewTab(file, $event)"
                      class="w-5 h-5 flex items-center justify-center rounded-full text-secondary-text hover:text-primary hover:bg-primary/10 transition-colors focus:outline-none cursor-pointer"
                      title="Open in new tab">
                <i class="fas fa-external-link-alt text-[9px]"></i>
              </button>
              }
              <button (click)="shareToHome(file, $event)"
                      class="w-5 h-5 flex items-center justify-center rounded-full text-secondary-text hover:text-primary hover:bg-primary/10 transition-colors focus:outline-none cursor-pointer"
                      title="Share to Home"
                      i18n-title="@@aiChat.shareToHome">
                <i class="fas fa-share text-[9px]"></i>
              </button>
              <button (click)="triggerDownload(file, $event)"
                      class="w-5 h-5 flex items-center justify-center rounded-full text-secondary-text hover:text-primary hover:bg-primary/10 transition-colors focus:outline-none cursor-pointer"
                      title="Download">
                <i class="fas fa-download text-[9px]"></i>
              </button>
            </div>
          </div>
          }
        </div>
        }

        <!-- Interaction Widget Section -->
        @if (message.interactionConfig && canShowInteractions) {
        <div class="chat-v2-interaction-section w-full pt-2 border-t border-secondary-border/60">
          <rapider-chat-interaction-widget
            [config]="message.interactionConfig"
            [messageId]="message.id"
            [isResponded]="message.interactionState?.status === 'responded' || message.interactionState?.status === 'skipped'"
            [selectedValues]="message.interactionState?.selectedValues || []"
            (onSubmit)="submitInteraction($event)"
            (onSkip)="skipInteraction()">
          </rapider-chat-interaction-widget>
        </div>
        }

        <!-- Company Knowledge notes the runtime saved during this turn (monochrome v2 chip) -->
        @if (message.memoryUpdates?.length) {
        <div class="chat-v2-memory-section flex flex-wrap gap-1.5 w-full min-w-0 pt-2">
          @for (note of message.memoryUpdates; track note.pageKey) {
          <button type="button"
                  class="chat-v2-memory-chip animate-fade-in"
                  (click)="openMemoryNote(note)"
                  nz-tooltip
                  [nzTooltipTitle]="note.statement"
                  [attr.aria-label]="memoryLabel(note) + ': ' + note.title">
            <span class="chat-v2-memory-chip-icon"><i class="fa-solid fa-book-open"></i></span>
            <span class="chat-v2-memory-chip-label">{{ memoryLabel(note) }}</span>
            <span class="chat-v2-memory-chip-title">{{ note.title }}</span>
            <i class="fa-solid fa-arrow-up-right-from-square chat-v2-memory-chip-open"></i>
          </button>
          }
        </div>
        }

        <!-- Workflow Plan Card (Phased reveal) -->
        @if (message.workflowPlan && canShowWorkflowPlan) {
        <div class="chat-v2-workflow-plan-section w-full pt-2.5 border-t border-secondary-border/60">
          <rapider-chat-workflow-plan-card
            [plan]="message.workflowPlan"
            [isConfirmed]="isWorkflowConfirmed()"
            (execute)="executeWorkflowPlan($event)">
          </rapider-chat-workflow-plan-card>
        </div>
        }

        <!-- Entity Data Card (Phased reveal: Tabular / Card view + Show in Canvas) -->
        @if (message.entityData && !hasEndpointAction(message.actions) && canShowData) {
        <div class="chat-v2-entity-data-section w-full pt-2.5 border-t border-secondary-border/60">
          <rapider-chat-entity-data-card
            [entityName]="message.entityData.entityName"
            [data]="message.entityData.data"
            [gridConfig]="gridConfig()"
            [isGridLoading]="isGridLoading()"
            (showInCanvas)="onShowInCanvas()">
          </rapider-chat-entity-data-card>
        </div>
        }

        <!-- JSONata Transformation Code Block & Execution -->
        @if (message.jsonataTransformation && canShowData) {
        <div class="chat-v2-jsonata-section w-full pt-2.5 border-t border-secondary-border/60">
          <div class="flex flex-col w-full rounded-xl shadow-xs border border-secondary-border bg-component-inner overflow-hidden">
            <div class="px-3.5 py-2 border-b border-secondary-border bg-alt-background flex items-center justify-between">
              <div class="flex items-center gap-2">
                <nz-tag class="!m-0 text-[10px] font-bold uppercase tracking-wider bg-section-background border-secondary-border text-warning shadow-xs flex items-center">
                  <i class="fas fa-code-branch mr-1 text-warning"></i>
                  <span i18n="@@aiChat.transformationTitle">Transformation</span>
                </nz-tag>
              </div>
            </div>
            <div class="p-3 bg-component-inner flex flex-col gap-2.5">
              <p class="text-[12px] text-primary-text mb-0 font-mono bg-alt-background p-2.5 rounded border border-secondary-border whitespace-pre-wrap overflow-x-auto">{{ message.jsonataTransformation }}</p>
              <div class="flex justify-end">
                <button nz-button
                        nzType="default"
                        (click)="executeJsonata()"
                        class="border-secondary-border text-secondary-text hover:border-primary hover:text-primary focus:outline-none flex items-center gap-2 rounded shadow-xs px-3 py-1 text-xs transition-colors">
                  <i class="fas fa-play text-[10px]"></i>
                  <span i18n="@@aiChat.executeTransformationButton">Execute Transformation</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        }

        <!-- Dynamic Template Renderer (HTML/Handlebars LLM Generated Layouts) -->
        @if (hasTemplate && canShowData) {
        <div class="chat-v2-template-section w-full pt-2.5 border-t border-secondary-border/60">
          <rapider-template-renderer
            [template]="templateContent"
            [data]="message.transformationResult || message.entityData?.data || {}">
          </rapider-template-renderer>
        </div>
        }

        <!-- Dynamic Component Placeholder (Fallbacks) -->
        @if (message.displayComponent && canShowData) {
        <div class="chat-v2-component-section w-full pt-2.5 border-t border-secondary-border/60">
          <div class="w-full border border-secondary-border rounded-xl bg-component-inner p-3 shadow-xs">
            <div class="flex items-center gap-2 mb-2">
              <i class="fas fa-puzzle-piece text-primary text-xs"></i>
              <span class="text-xs font-bold uppercase tracking-wider text-secondary-text">Component: {{ message.displayComponent.componentName || 'Unknown' }}</span>
            </div>
            <pre class="text-[11px] text-primary-text m-0 overflow-x-auto custom-scrollbar p-2.5 bg-alt-background border border-secondary-border rounded">{{ message.displayComponent.data | json }}</pre>
          </div>
        </div>
        }

        <!-- UNIFIED ACTION CARDS AT END OF MESSAGE CONTENT (Phased reveal) -->
        @if (hasActions && canShowActions) {
        <div class="chat-v2-actions-container flex flex-col gap-2.5 w-full pt-2.5 border-t border-secondary-border/60">
          @for (action of visibleActions; track $index) {
          <rapider-chat-v2-action-card
            [action]="action"
            [index]="$index"
            [totalCount]="visibleActions.length"
            [isLatest]="isLatest"
            [isCompleted]="isActionCompleted(action) || batchSubmitted()"
            [isActive]="isActionActive($index)"
            [showButtons]="isLatest && !isBatchMode"
            [isOptimisticDone]="batchSubmitted()"
            (onExecute)="handleActionExecute($event, $index)"
            (onToggleActive)="handleActionToggle($event, $index)">
          </rapider-chat-v2-action-card>
          }

          <!-- One decision for all actions of the message (Execute All / Discard All) -->
          @if (showBatchBar) {
          <div class="chat-v2-batch-bar flex items-center justify-end gap-1.5 pt-0.5">
            <button
              type="button"
              class="h-7 px-3 rounded-md text-[12.5px] font-medium text-[#52525B] hover:bg-[#F4F4F5] hover:text-[#18181B] dark:text-[#A1A1AA] dark:hover:bg-white/5 dark:hover:text-[#F4F4F5] transition-colors cursor-pointer"
              (click)="discardAllActiveActions()">
              <i class="fas fa-trash-alt text-[10px] mr-1.5" aria-hidden="true"></i>
              {{ config.texts.discardAll || config.texts.batchReject }}
            </button>
            <button
              type="button"
              nz-tooltip
              [nzTooltipTitle]="executeAllTooltip()"
              class="h-7 px-3.5 inline-flex items-center gap-1.5 rounded-md bg-[#18181B] text-[12.5px] font-medium text-white shadow-[0_1px_2px_rgba(0,0,0,0.08)] hover:bg-[#27272A] dark:bg-[#F4F4F5] dark:text-[#18181B] dark:hover:bg-white transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-40"
              [disabled]="batchRunCount === 0"
              (click)="executeAllActiveActions()">
              <i class="fas fa-check-double text-[11px]" aria-hidden="true"></i>
              {{ executeAllLabel }}
            </button>
          </div>
          }
        </div>
        }

        <!-- FOOTER TOOLBAR (Inside bubble container) -->
        <div class="chat-v2-footer-toolbar flex items-center justify-between w-full pt-1 text-[11px] text-secondary-text">
          <div class="flex items-center gap-1.5">
            @if (!message.isUser && message.id) {
            <!-- Agent Debug Drawer Trigger Button -->
            <button
              nz-tooltip
              [nzTooltipTitle]="config.texts.inspectAiResponse"
              (click)="isDebugDrawerOpen.set(true)"
              class="chat-v2-debug-btn w-6 h-6 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none cursor-pointer"
              aria-label="Inspect AI Response">
              <i class="fa-regular fa-magnifying-glass-chart text-[12px]"></i>
            </button>
            }

            @if (!message.isUser && message.text) {
            <!-- Copy Message Text Button -->
            <button
              nz-tooltip
              [nzTooltipTitle]="isCopied() ? config.texts.copiedAction : config.texts.copyAction"
              (click)="copyMessageText()"
              class="chat-v2-copy-btn w-6 h-6 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none cursor-pointer"
              aria-label="Copy Message Text">
              <i class="fas" [ngClass]="isCopied() ? 'fa-check text-success' : 'fa-regular fa-copy'"></i>
            </button>
            }

            @if (!message.isUser && (message.text || message.entityData)) {
            <!-- Save to Space Action Button -->
            <button
              nz-tooltip
              nzTooltipTitle="Save to Space"
              (click)="saveToSpace()"
              class="chat-v2-save-btn w-6 h-6 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none cursor-pointer"
              aria-label="Save to Space">
              <i class="fas fa-save text-[11px]"></i>
            </button>
            }
          </div>

          <!-- Timestamp -->
          <span class="chat-v2-timestamp text-[10px] text-secondary-text select-none">
            {{ formattedTime }}
          </span>
        </div>

      </div>
      }

    }
  }

  <!-- 4. Web Developer Tooling: Agent Debug Drawer Slide-Over -->
  <rapider-agent-debug-drawer
    [isOpen]="isDebugDrawerOpen()"
    [message]="message"
    (isOpenChange)="isDebugDrawerOpen.set($event)">
  </rapider-agent-debug-drawer>

  <!-- 5. Attachment Image Preview Modal -->
  <nz-modal
    [(nzVisible)]="isPreviewModalVisible"
    [nzTitle]="previewFile()?.name || 'Preview'"
    [nzFooter]="previewFooter"
    (nzOnCancel)="closeAttachmentPreview()"
    nzWidth="80vw"
    nzClassName="attachment-preview-modal">
    <ng-container *nzModalContent>
      <div class="flex items-center justify-center w-full min-h-[50vh] bg-alt-background rounded-lg overflow-hidden">
        @if (previewFile()?.url) {
        <img [src]="previewFile()?.url"
             alt="Attachment Preview"
             class="max-w-full max-h-[70vh] object-contain" />
        } @else {
        <i class="fas fa-image text-4xl text-secondary-text"></i>
        }
      </div>
    </ng-container>
    <ng-template #previewFooter>
      <div class="flex justify-end gap-3">
        <button nz-button nzType="default" (click)="closeAttachmentPreview()">
          {{ config.texts.closePreviewBtn }}
        </button>
        <button nz-button nzType="primary"
                (click)="previewFile() ? downloadAttachment(previewFile()!) : null"
                class="bg-primary text-white border-none flex items-center gap-2 shadow-xs">
          <i class="fas fa-download"></i> {{ config.texts.downloadBtn }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

</div>
}
